export default "__VITE_PUBLIC_ASSET__d371ea3e__"